import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import css from  './ScoreDefinitionLinks.scss';

export default class ScoreDefinitionLinks extends React.Component {

  render() {
    return (
      <Button.Group className={css['icon-group']} compact size='mini' vertical>
        <Button className={`factors-btn ${css['icon-link']}`}
                content="View Score Factors"
                icon="eye"
                onClick={this.props.goToScoreDefinitions} />
        <Button className={`chart-btn ${css['icon-link']}`}
                content="View Changes By Week"
                disabled
                icon="chart line" />
      </Button.Group>
    )
  }

}

ScoreDefinitionLinks.propTypes = {
  goToScoreDefinitions: PropTypes.func.isRequired
};
